import { APIError } from "source/shared/types"

export const genericRetryableErrorMessage =
  "Your donation could not be processed. Please try again."

export class DonationFormInvariantError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "DonationFormInvariantError"
  }
}
export class RetryableDonationFormInvariantError extends DonationFormInvariantError {
  constructor() {
    super(genericRetryableErrorMessage)
    this.name = "RetryableDonationFormInvariantError"
  }
}

export class DonationFormSubmissionError extends Error {
  public apiError?: APIError
  public originalError?: unknown
  public responseStatus: string
  public path: string

  static fromApiError(
    apiError: APIError,
    {
      path,
    }: {
      path: string
    },
  ): DonationFormSubmissionError {
    const presumedActualApiError = apiError.errors[0]

    return new DonationFormSubmissionError(presumedActualApiError.detail, {
      apiError,
      responseStatus: presumedActualApiError.status,
      path,
    })
  }

  static fromUnknownError(
    error: unknown,
    {
      path,
    }: {
      path: string
    },
  ): DonationFormSubmissionError {
    return new DonationFormSubmissionError("Client error", {
      originalError: error,
      responseStatus: "0",
      path: path,
    })
  }

  constructor(
    message: string,
    {
      apiError,
      originalError,
      responseStatus,
      path,
    }: {
      apiError?: APIError
      originalError?: unknown
      responseStatus: string
      path: string
    },
  ) {
    super(message)

    this.apiError = apiError
    this.originalError = originalError
    this.responseStatus = responseStatus
    this.path = path
    this.name = "DonationFormSubmissionError"
  }
}
